import { AboutMeData, Game, GameEngine, LinkImageSource, MediaType, Platform } from "./types";

export const PersonalInfo: AboutMeData = {
  name: "Diego Alejandro Salazar",
  role: "Game developer",
  introduction: "Aspiring game developer with a strong interest in interactive experiences and gameplay programming. I work with Unity and Unreal Engine to design and implement core mechanics, combining technical problem-solving with thoughtful game design.",
  description: "I recently graduated in Information Engineering for Videogames and AR, where I developed multiple projects using Unity and Unreal Engine. I'm inspired by games like Dark Souls and Undertale—titles that blend atmosphere, emotion, and clever design. I enjoy creating gameplay systems, experimenting with mechanics, and building experiences that feel meaningful and fun. I'm now looking to join a studio where I can grow as a developer, learn from experienced teammates, and contribute to making great games.",
  image: `${process.env.PUBLIC_URL}/images/Profile.png`,
  cvUri: `${process.env.PUBLIC_URL}/files/CV.pdf`,
  links: {
    github: "https://github.com/DiegoAlejandroSalazar",
    itchIO: "https://diego-alejandro-salazar.itch.io",
    linkedIn: "https://www.linkedin.com/in/diego-alejandro-salazar-849868257/",
  }
};

export const games: Game[] = [
  {
    name: "Get Dressed",
    description: "In a post-apocalyptic world ruled by a drag queen demon king who has taken over the citizens' clothes, you will have to defeat the possessed clothes with your magic net.",
    genres: ["2D", "Infinite runner"],
    platforms: [Platform.Windows],
    engine: GameEngine.Unity,
    source: { name: "USER EXPERIENCE DESIGN E GRAFICA 2D", url: "https://learn.univpm.it/course/view.php?id=16401" },
    links: [
      { source: LinkImageSource.ItchIo, url: "https://diego-alejandro-salazar.itch.io/get-dressed" },
    ],
    media: [
      { source: "/images/games/Get Dressed/video_get_dressed.mp4", type: MediaType.Video },
      { source: "/images/games/Get Dressed/Screenshot _1.png", type: MediaType.Image },
      { source: "/images/games/Get Dressed/Screenshot_2.png", type: MediaType.Image },
      { source: "/images/games/Get Dressed/Screenshot_3.png", type: MediaType.Image },
      { source: "/images/games/Get Dressed/Screenshot_4.png", type: MediaType.Image },
    ],
  },
  {
    name: "Rancitelli Journey",
    description: "You woke up in the heart of Rancielli's \"Ferro di cavallo\" and you'll have to figure out what happened to you the night before, while battling the police and discovering Pescara's iconic places.",
    genres: ["text adventure game"],
    platforms: [Platform.Windows],
    engine: GameEngine.Terminal,
    source: { name: "PROGRAMMAZIONE AD OGGETTI E STRUTTURE DATI", url: "https://learn.univpm.it/course/view.php?id=16403" },
    links: [
      { source: LinkImageSource.Github, url: "https://github.com/DiegoAlejandroSalazar/Rancitelli-journey" },
      { source: LinkImageSource.ItchIo, url: "https://diego-alejandro-salazar.itch.io/rancitelly-journey" },
    ],
    media: [
      { source: "/images/games/Rancitelly Journey/Screenshot_1.png", type: MediaType.Image },
      { source: "/images/games/Rancitelly Journey/Screenshot_2.png", type: MediaType.Image },
      { source: "/images/games/Rancitelly Journey/Screenshot_3.png", type: MediaType.Image },
      { source: "/images/games/Rancitelly Journey/Screenshot_4.png", type: MediaType.Image },
      { source: "/images/games/Rancitelly Journey/Screenshot_5.png", type: MediaType.Image },
    ],
  },
  {
    name: "Proxima drift",
    description: "Game made for a game jam where you are a little astronaut trapped in his ship with the goal of fixing it.",
    genres: ["3D", "Third person"],
    platforms: [Platform.Windows],
    engine: GameEngine.Unity,
    links: [
      { source: LinkImageSource.Github, url: "https://github.com/Salo0909/OpenDataGameJamProject" },
      { source: LinkImageSource.ItchIo, url: "https://diego-alejandro-salazar.itch.io/proxima-drift" },
    ],
    media: [
      { source: "/images/games/Proxima drift/Proximadrift_gameplay.mp4", type: MediaType.Video },
      { source: "/images/games/Proxima drift/Screenshot_1.png", type: MediaType.Image },
      { source: "/images/games/Proxima drift/Screenshot_2.png", type: MediaType.Image },
      { source: "/images/games/Proxima drift/Screenshot_3.png", type: MediaType.Image },
      { source: "/images/games/Proxima drift/Screenshot_4.png", type: MediaType.Image },
      { source: "/images/games/Proxima drift/Screenshot_5.png", type: MediaType.Image },
      { source: "/images/games/Proxima drift/Screenshot_6.png", type: MediaType.Image },
    ],
  },
  {
    name: "Cum & Go",
    description: "Follow the long journey of the sperm inside the female reproductive system in a playful and cartoonish way.",
    genres: ["2D", "serius game", "top-down"],
    platforms: [Platform.Windows],
    engine: GameEngine.Unity,
    source: { name: "PROGRAMMAZIONE DI VIDEOGAME E DI SISTEMI DI REALTA' VIRTUALE", url: "https://learn.univpm.it/course/view.php?id=19396" },
    links: [
      { source: LinkImageSource.Github, url: "https://github.com/Luci1818/Cum-and-Go" },
      { source: LinkImageSource.ItchIo, url: "https://diego-alejandro-salazar.itch.io/cum-go" },
    ],
    media: [
      { source: "/images/games/Cum & Go/Cum_&_Go.mp4", type: MediaType.Video },
      { source: "/images/games/Cum & Go/Screenshot_1.png", type: MediaType.Image },
      { source: "/images/games/Cum & Go/Screenshot_2.png", type: MediaType.Image },
      { source: "/images/games/Cum & Go/Screenshot_3.png", type: MediaType.Image },
      { source: "/images/games/Cum & Go/Screenshot_4.png", type: MediaType.Image },
      { source: "/images/games/Cum & Go/Screenshot_5.png", type: MediaType.Image },
      { source: "/images/games/Cum & Go/Screenshot_6.png", type: MediaType.Image },
      { source: "/images/games/Cum & Go/Screenshot_7.png", type: MediaType.Image },
      { source: "/images/games/Cum & Go/Screenshot_8.png", type: MediaType.Image },
      { source: "/images/games/Cum & Go/Screenshot_9.png", type: MediaType.Image },
      { source: "/images/games/Cum & Go/Screenshot_10.png", type: MediaType.Image },
    ],
  },
  {
    name: "Juce audio plug-in ",
    description: "DSP Distortion, Delay & Reverb made on juce",
    genres: ["plug-in", "audio", "C++"],
    platforms: [Platform.Windows],
    engine: GameEngine.Juce,
    links: [
      { source: LinkImageSource.Github, url: "https://github.com/Kypor/DistortionVST" },
    ],
    media: [
      { source: "/images/games/Juce/Screenshot_1.png", type: MediaType.Image },
    ],
  },
  {
    name: "Unilingo",
    description: "Learn Japanese words and characters with this game even without a Wi-Fi connection.",
    genres: ["2D", "Serius game"],
    platforms: [Platform.Windows],
    engine: GameEngine.Unity,
    links: [
      { source: LinkImageSource.Github, url: "https://github.com/Kypor/TirocinioAiDefinitivo" },
      { source: LinkImageSource.ItchIo, url: "https://diego-alejandro-salazar.itch.io/unilingo" },
    ],
    media: [
      { source: "/images/games/Unilingo/Screenshot_1.png", type: MediaType.Image },
      { source: "/images/games/Unilingo/Screenshot_2.png", type: MediaType.Image },
      { source: "/images/games/Unilingo/Screenshot_3.png", type: MediaType.Image },
      { source: "/images/games/Unilingo/Screenshot_4.png", type: MediaType.Image },
      { source: "/images/games/Unilingo/Screenshot_5.png", type: MediaType.Image },
      { source: "/images/games/Unilingo/Screenshot_6.png", type: MediaType.Image },
      { source: "/images/games/Unilingo/Screenshot_7.png", type: MediaType.Image },
    ],
  },
  {
    name: "Escape",
    description: "Solve the puzzles to escape from a house and something...",
    genres: ["3D", "First person", "Puzzle game", "Horror"],
    platforms: [Platform.Windows],
    engine: GameEngine.Unity,
    links: [
      { source: LinkImageSource.Github, url: "https://github.com/Salo0909/GameDesignProject" },
      { source: LinkImageSource.ItchIo, url: "https://diego-alejandro-salazar.itch.io/escape" },
    ],
    media: [
      { source: "/images/games/Escape/Screenshot_1.png", type: MediaType.Image },
      { source: "/images/games/Escape/Screenshot_2.png", type: MediaType.Image },
      { source: "/images/games/Escape/Screenshot_3.png", type: MediaType.Image },
      { source: "/images/games/Escape/Screenshot_4.png", type: MediaType.Image },
      { source: "/images/games/Escape/Screenshot_5.png", type: MediaType.Image },
      { source: "/images/games/Escape/Screenshot_6.png", type: MediaType.Image },
      { source: "/images/games/Escape/Screenshot_7.png", type: MediaType.Image },
      { source: "/images/games/Escape/Screenshot_8.png", type: MediaType.Image },
      { source: "/images/games/Escape/Screenshot_9.png", type: MediaType.Image },
      { source: "/images/games/Escape/Screenshot_10.png", type: MediaType.Image },
    ],
  },
  {
    name: "A clock's tale",
    description: "Protect your clock tower from crazy robots by defending yourself with your extendable arm.",
    genres: ["3D", "Third person", "Puzzle game"],
    platforms: [Platform.Windows],
    engine: GameEngine.Unreal,
    source: { name: "PROGRAMMAZIONE AVANZATA DI VIDEOGAME E DI SISTEMI DI REALTA' VIRTUALE", url: "https://learn.univpm.it/course/view.php?id=22639" },
    links: [
      { source: LinkImageSource.Github, url: "https://github.com/DiegoAlejandroSalazar/ProgrammazioneAvanzata" },
      { source: LinkImageSource.ItchIo, url: "https://diego-alejandro-salazar.itch.io/a-clocks-tale" },
    ],
    media: [
      { source: "/images/games/A clock's tale/gameplay_clock's_tale.mp4", type: MediaType.Video },
      { source: "/images/games/A clock's tale/Screenshot_1.png", type: MediaType.Image },
      { source: "/images/games/A clock's tale/Screenshot_2.png", type: MediaType.Image },
      { source: "/images/games/A clock's tale/Screenshot_3.png", type: MediaType.Image },
      { source: "/images/games/A clock's tale/Screenshot_4.png", type: MediaType.Image },
      { source: "/images/games/A clock's tale/Screenshot_5.png", type: MediaType.Image },
      { source: "/images/games/A clock's tale/Screenshot_6.png", type: MediaType.Image },
      { source: "/images/games/A clock's tale/Screenshot_7.png", type: MediaType.Image },
      { source: "/images/games/A clock's tale/Screenshot_8.png", type: MediaType.Image },
    ],
  },
  {
    name: "Shoot the bitch",
    description: "Shoot the right monster!. (a copy of a game made by https://crowbarska.itch.io",
    genres: ["2D", "point and click"],
    platforms: [Platform.Windows],
    engine: GameEngine.Unity,
    links: [
      { source: LinkImageSource.ItchIo, url: "https://diego-alejandro-salazar.itch.io/shoot-the-bitch" },
    ],
    media: [
      { source: "/images/games/Shoot the bitch/Screenshot_1.png", type: MediaType.Image },
      { source: "/images/games/Shoot the bitch/Screenshot_2.png", type: MediaType.Image },
      { source: "/images/games/Shoot the bitch/Screenshot_3.png", type: MediaType.Image },
      { source: "/images/games/Shoot the bitch/Screenshot_4.png", type: MediaType.Image },
    ],
  }
];